import { ref } from "vue";
import { translate } from "@/composables/translate";

export default function useModalCurriculum() {

  let displayModalTitle = ref(""); 

  function toggleCreateUpdateTitle(type, title) {
    switch (type) {
      case "create":
        displayModalTitle.value = translate("add " + title, "ucfirst");
        break;
      case "update":
        displayModalTitle.value = translate("update " + title, "ucfirst");
        break;
    }
  }

  return {
    toggleCreateUpdateTitle,
    displayModalTitle
  };
}
